angular.module('component-tabindex', [])
	.directive('ctTabindex', ctTabindexDirective);

function ctTabindexDirective() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: postLink
	};

	function postLink(scope, element, attrs, NgModelCtrl) {
		var check = scope[attrs.ctTabindex],
			tabindex,
			watcher;

		if (!attrs.tabindex)
			throw new Error('There is no TABINDEX attr in ELEMENT!');

		tabindex = parseInt(attrs.tabindex);

		element.on('focus', onFocus);
		element.on('blur', onBlur);

		function onFocus() {
			watcher = scope.$watch(function () {
				return NgModelCtrl.$modelValue;
			}, function () {
				var check = scope.ClientCards[attrs.ctTabindex];
				if (check(NgModelCtrl)) {
					setTimeout(function() {
						if (document.querySelector('[tabindex="' + (tabindex + 1) + '"]')) {
							document.querySelector('[tabindex="' + (tabindex + 1) + '"]').focus();
						}
					}, 10)
				}
			});
		}

		function onBlur() {
			if (typeof watcher == 'function') {
				watcher();
			}

			watcher = null;
		}
	}
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/component-tabindex/src/component-tabindex.js
 ** module id = 354
 ** module chunks = 1
 **/